import React from "react";

export const CloseIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path d="M9 3L3 9M3 3L9 9" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
